import { useEffect } from 'react';
import { connect } from 'react-redux';
import { loadSubscriptionRules } from '../redux/user/actions';

/**
 * Fetches plan VP limits from GET /payment/GetSubscriptionRules once per session.
 */
const SubscriptionRulesLoader = ({
  subscriptionRulesByPlan,
  subscriptionRulesByPlanLoading,
  loadSubscriptionRules: loadRules,
}) => {
  useEffect(() => {
    if (!subscriptionRulesByPlan && !subscriptionRulesByPlanLoading) {
      loadRules();
    }
  }, [subscriptionRulesByPlan, subscriptionRulesByPlanLoading, loadRules]);

  return null;
};

const mapStateToProps = (state) => ({
  subscriptionRulesByPlan: state.User?.subscriptionRulesByPlan,
  subscriptionRulesByPlanLoading: state.User?.subscriptionRulesByPlanLoading,
});

export default connect(mapStateToProps, { loadSubscriptionRules })(SubscriptionRulesLoader);
